(function () {
  const PREORDER_KEY = '_preorder';

  const cartHasPreorder = (cart) =>
    Array.isArray(cart?.items) &&
    cart.items.some((item) => item.properties?.[PREORDER_KEY] === 'true');

  const syncPreorderCartAttribute = async (cart) => {
    const root = window.Shopify?.routes?.root || '/';
    let currentCart = cart;

    if (!currentCart) {
      const response = await fetch(`${root}cart.js`);
      if (!response.ok) return;
      currentCart = await response.json();
    }

    const hasPreorder = cartHasPreorder(currentCart);
    const currentValue = currentCart.attributes?.[PREORDER_KEY] || '';
    const nextValue = hasPreorder ? 'true' : '';

    if (currentValue === nextValue) return;

    await fetch(`${root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { [PREORDER_KEY]: nextValue } })
    });
  };

  document.addEventListener('cart:change', (event) => {
    syncPreorderCartAttribute(event.detail?.cart);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncPreorderCartAttribute());
  } else {
    syncPreorderCartAttribute();
  }
})();
